module.exports = __webpack_public_path__ + "static/media/font_bold.8b13d875.woff2";